
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, IUnit, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * UnitLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class UnitLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<IUnit[]> {
        return this.$apiService.sendAuth("IUnitLookupService/Lookup", pCriteria);
    }
}
